module.exports = {"410482001":"煤山街道","410482002":"风穴路街道","410482003":"钟楼街道","410482004":"洗耳河街道","410482005":"汝南街道","410482101":"寄料镇","410482102":"温泉镇","410482103":"临汝镇","410482104":"小屯镇","410482105":"杨楼镇","410482106":"蟒川镇","410482107":"庙下镇","410482108":"米庙镇","410482109":"陵头镇","410482110":"纸坊镇","410482111":"大峪镇","410482112":"夏店镇","410482113":"焦村镇","410482202":"王寨乡","410482207":"骑岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410482.json
// module id = 1565
// module chunks = 0